/* Club Rehab: one native Shopify consent source; Clarity ConsentV2 after opt-in. */
(() => {
  'use strict';
  const config = document.querySelector('[data-crg-clarity-config]');
  if (!config || window.__crgClarityGate) return;
  const project = config.dataset.projectId || '';
  if (config.dataset.enabled !== 'true' || project !== 'ywmnt7x2db') return;

  const origin = 'https://clubrehabgolf.com';
  const allowedPath = /^(?:\/$|\/products\/[a-z0-9-]+\/?$|\/collections(?:\/[a-z0-9-]+)?\/?$)/;
  const status = {state: 'waiting'};
  window.__crgClarityGate = status;
  let privacy = null;
  let installed = false;
  let ownedClarity = null;
  let ownedBootstrap = null;
  let consentSyncPending = false;
  let runtimeConsentReady = false;
  let consentEpoch = 0;
  let lastAnalyticsConsent = 'denied';
  let checkoutAt = -Infinity;

  function safeUrl(raw, referrer) {
    if (!raw && referrer) return true;
    let url;
    try { url = new URL(raw, origin); } catch (_) { return false; }
    if (url.protocol !== 'https:' || url.username || url.password || url.hash) return false;
    if (url.origin !== origin) return !!referrer && url.pathname === '/' && !url.search;
    if (!allowedPath.test(url.pathname)) return false;
    for (const [key, value] of url.searchParams) {
      if (key === 'variant' && url.pathname.startsWith('/products/') && /^\d{1,20}$/.test(value)) continue;
      if (key === 'page' && url.pathname.startsWith('/collections') && /^[1-9]\d{0,3}$/.test(value)) continue;
      if (key === 'currency' && /^[A-Z]{3}$/.test(value)) continue;
      return false;
    }
    return true;
  }

  function currentConsent() {
    const denied = {analytics_Storage: 'denied', ad_Storage: 'denied'};
    try {
      if (!privacy || config.dataset.customerPresent !== 'false' ||
          navigator.globalPrivacyControl === true || window.Shopify.designMode === true ||
          !safeUrl(location.href, false) || !safeUrl(document.referrer, true)) return denied;
      const consent = privacy.currentVisitorConsent();
      const analyticsAllowed = privacy.analyticsProcessingAllowed() === true;
      const marketingAllowed = privacy.marketingAllowed() === true;
      const sharingAllowed = privacy.saleOfDataAllowed() === true;
      return {
        analytics_Storage: consent.analytics === 'yes' && analyticsAllowed && sharingAllowed ? 'granted' : 'denied',
        ad_Storage: consent.marketing === 'yes' && marketingAllowed && sharingAllowed ? 'granted' : 'denied'
      };
    } catch (_) { return denied; }
  }

  function syncOwnedConsent() {
    runtimeConsentReady = false;
    if (consentSyncPending) return;
    consentSyncPending = true;
    try {
      // During the SDK's own restart, its dispatcher remains ours but consentv2 is inactive.
      // Wait through that SDK's metadata API and apply the latest native consent when ready.
      ownedClarity('metadata', metadata => {
        consentSyncPending = false;
        try {
          if (metadata?.projectId !== project) return;
          const latest = currentConsent();
          ownedClarity('consentv2', latest);
          runtimeConsentReady = latest.analytics_Storage === 'granted';
        } catch (_) { status.state = 'consent-update-failed'; }
      }, false);
    } catch (_) {
      consentSyncPending = false;
      status.state = 'consent-update-failed';
    }
  }

  function syncConsent() {
    const consent = currentConsent();
    if (consent.analytics_Storage !== lastAnalyticsConsent) consentEpoch += 1;
    lastAnalyticsConsent = consent.analytics_Storage;
    config.dataset.analyticsConsent = consent.analytics_Storage;
    config.dataset.adConsent = consent.ad_Storage;
    if (installed) {
      // Denial is the vendor's limited cookieless mode, not an SDK shutdown.
      try {
        if (ownedClarity) syncOwnedConsent();
        else if (window.clarity === ownedBootstrap) ownedBootstrap('consentv2', consent);
        else status.state = 'ownership-lost';
      }
      catch (_) { status.state = 'consent-update-failed'; }
      return;
    }
    if (consent.analytics_Storage !== 'granted') return;
    // Do not add to, or change consent for, an installation we do not own.
    if (typeof window.clarity !== 'undefined' || document.querySelector('script[src*="clarity.ms/tag/"]')) {
      status.state = 'existing-installation';
      return;
    }
    installed = true;
    ownedBootstrap = window.clarity = function () { (ownedBootstrap.q = ownedBootstrap.q || []).push(arguments); };
    ownedBootstrap('consentv2', consent);
    // The project tag loads the SDK asynchronously; its onload is not SDK readiness.
    // Capture only the dispatcher executing our queued callback in the official SDK.
    // This stable dispatcher closes over that SDK module and survives internal restarts.
    ownedBootstrap('metadata', metadata => {
      try {
        const runtime = window.clarity;
        const version = typeof runtime === 'function' ? runtime.v : null;
        if (ownedClarity || !installed || metadata?.projectId !== project || typeof version !== 'string' ||
            !/^\d+\.\d+\.\d+(?:-[A-Za-z0-9]+(?:[.-][A-Za-z0-9]+)*)?$/.test(version)) return;
        const runtimeScript = document.querySelector('script[src="https://scripts.clarity.ms/' + version + '/clarity.js"]');
        if (!runtimeScript || document.currentScript !== runtimeScript) return;
        ownedClarity = runtime;
        syncOwnedConsent();
      } catch (_) {}
    }, false);
    const script = document.createElement('script');
    script.async = true;
    script.referrerPolicy = 'no-referrer';
    script.src = 'https://www.clarity.ms/tag/' + project;
    script.onload = () => {
      status.state = 'loaded';
      syncConsent();
    };
    script.onerror = () => { status.state = 'load-failed'; };
    status.state = 'loading';
    document.head.appendChild(script);
  }

  function canMeasure() {
    return installed && status.state === 'loaded' && typeof ownedClarity === 'function' && runtimeConsentReady &&
      typeof window.clarity === 'function' && window.clarity.v === ownedClarity.v &&
      currentConsent().analytics_Storage === 'granted';
  }

  window.crgClarityBeginCartAdd = function () {
    try {
      if (!canMeasure()) return null;
      const epoch = consentEpoch;
      const startUrl = location.href;
      let finished = false;
      return function () {
        if (finished) return;
        finished = true;
        try {
          if (epoch === consentEpoch && startUrl === location.href && canMeasure()) {
            ownedClarity('event', 'crg_add_to_cart_success');
          }
        } catch (_) {}
      };
    } catch (_) { return null; }
  };

  document.addEventListener('click', event => {
    try {
      if (!event.isTrusted || event.defaultPrevented || !canMeasure()) return;
      const button = event.target instanceof Element ? event.target.closest('#CartDrawer-Checkout') : null;
      if (!button || !button.isConnected || button.tagName !== 'BUTTON' || button.type !== 'submit' || button.disabled || button.matches(':disabled') || button.getAttribute('aria-disabled') === 'true' ||
          button.name !== 'checkout' || button.form?.id !== 'CartDrawer-Form' || !button.form.isConnected ||
          button.form.method.toLowerCase() !== 'post') return;
      const action = new URL(button.form.action, origin);
      if (action.origin !== origin || action.pathname !== '/cart' || action.search || action.hash || action.username || action.password) return;
      const now = performance.now();
      if (now - checkoutAt < 1500) return;
      checkoutAt = now;
      ownedClarity('event', 'crg_checkout_button_click');
    } catch (_) {}
  });

  // No custom banner, cookie writes, interaction traps, stop/restart, or route hooks.
  document.addEventListener('visitorConsentCollected', syncConsent);
  try {
    if (!window.Shopify) return;
    if (window.Shopify.customerPrivacy) {
      privacy = window.Shopify.customerPrivacy;
      syncConsent();
    } else if (typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], error => {
        if (error || !window.Shopify.customerPrivacy) {
          status.state = 'privacy-api-unavailable';
          return;
        }
        privacy = window.Shopify.customerPrivacy;
        syncConsent();
      });
    }
  } catch (_) { status.state = 'privacy-api-unavailable'; }
})();

